module.exports = __webpack_public_path__ + "assets/img/key-success-story-hero.a1291c4c.jpg";